export default __webpack_public_path__ + "static/media/illustration-data.13fb4bf9.svg";